export default {
    businessName: '주식회사 바로고',
    ceoName: '이태권',
    businessNumber: '1198687135',
    formattedFullAddress: '서울 강남구 언주로 134길 32 (논현동 117), 씨앤에스빌딩',
    businessType: '서비스',
    businessCondition: '소프트웨어개발',
    ceoEmail: 'finance@barogo.com',
};
